import { Charts } from './Charts';
import CollectionMethodChartsDataProvider from './contexts/CollectionMethodChartsDataContext';

const CollectionMethodWrapper = () => {
    return (
        <CollectionMethodChartsDataProvider>
            <Charts />
        </CollectionMethodChartsDataProvider>
    );
};

export default CollectionMethodWrapper;
